import './style/styles-people.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/people'

Object.values(features).forEach(createComponent)
